import { IHEXTAR_AUTH } from '@/constants';

export async function AESEncryptPassword(password) {
    const keyString = IHEXTAR_AUTH.KEY_STRING;
    const ivStringBase64 = IHEXTAR_AUTH.KEY_IV;

    // Convert key string to bytes
    const keyBytes = new TextEncoder().encode(keyString);

    // Convert IV from base64 to bytes
    const ivBytes = Uint8Array.from(atob(ivStringBase64), c => c.charCodeAt(0));

    // Import key for AES-CBC
    const cryptoKey = await crypto.subtle.importKey(
        "raw",
        keyBytes,
        { name: "AES-CBC" },
        false,
        ["encrypt"]
    );

    // Encrypt
    const passwordBytes = new TextEncoder().encode(password);
    const encryptedBuffer = await crypto.subtle.encrypt(
        { name: "AES-CBC", iv: ivBytes },
        cryptoKey,
        passwordBytes
    );

    // Convert result to base64
    const encryptedBase64 = btoa(
        String.fromCharCode(...new Uint8Array(encryptedBuffer))
    );

    return encryptedBase64;
}

export function JWTDecode(token) {
    try {
        if (!token) {
            return null;
        }

        const parts = token.split('.');

        if (parts.length !== 3) {
            return null;
        }

        const payload = parts[1];

        // Convert Base64URL to Base64
        const base64 = payload
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        // Add Base64 padding if required
        const paddedBase64 = base64.padEnd(
            base64.length + (4 - base64.length % 4) % 4,
            '='
        );

        // Decode Base64
        const decoded = atob(paddedBase64);

        // Handle UTF-8 properly
        const bytes = Uint8Array.from(decoded, c => c.charCodeAt(0));

        const json = new TextDecoder().decode(bytes);

        return JSON.parse(json);
    } catch (error) {
        console.error('Failed to decode JWT token:', error);

        return null;
    }
}